import React from 'react'
import { useParams } from 'react-router-dom'
import SinglePostWp from '../components/Public/Posts/SinglePostWp'

function SingleFootballBlogWp() {
    const {id} = useParams()
    return (
        <div>
            <SinglePostWp id={id} />
        </div>
    )
}
export default SingleFootballBlogWp